/**
 * Tastaturauslösung für Bedienelemente, die kein `<button>` sind.
 *
 * Der Altclient gibt an mehreren Stellen `span`, `div` oder `a` als
 * Bedienelement aus, und die Klassennamen sind verbindlich (REQ-00 §13) — das
 * Element lässt sich also nicht gegen ein `<button>` tauschen. Damit solche
 * Elemente ohne Maus benutzbar sind, brauchen sie `role="button"`,
 * `tabIndex={0}` und die Auslösung über `Enter`/`Space` (REQ-17 §3).
 */

import type { KeyboardEvent } from 'react';

/** Die Tasten, die ein `role="button"` laut WAI-ARIA auslöst. */
export function isActivateKey(key: string): boolean {
  return key === 'Enter' || key === ' ';
}

/**
 * `onKeyDown`-Behandlung für ein solches Element.
 *
 * `preventDefault` verhindert das Scrollen bei `Space` und das Folgen eines
 * `href` bei `Enter`. `stopPropagation` ist nötig, weil einige Elemente in
 * einer Hülle sitzen, die dieselben Tasten auswertet — die Eingabegruppe der
 * Auswahlliste öffnet mit `Enter` ebenfalls das Popup und würde es sonst sofort
 * wieder schließen.
 */
export function onActivateKey<T extends HTMLElement>(
  activate: () => void,
): (event: KeyboardEvent<T>) => void {
  return (event) => {
    if (!isActivateKey(event.key)) return;
    event.preventDefault();
    event.stopPropagation();
    activate();
  };
}
